import React from 'react';
import './CategoriaBtn.scss';
import { connect } from 'react-redux';

const CategoriaBtn = (props) => {
    const { nombre, active } = props
    return (
        <div className="categoria-btn-container pointer">
            <div className="icono">
                {
                    (active === true) &&
                    (
                        <div className="icono-selected"></div>
                    )
                }
            </div>
            <div className="nombre">
                <p> {nombre[0].toUpperCase() + nombre.slice(1).toLowerCase()}</p>
            </div>
        </div>
    )
}

const mapStateToProps = state => state

export default connect(mapStateToProps, null)(CategoriaBtn)